import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import rootReducer from 'lib/reducers';
import initReactFastclick from 'react-fastclick';
import 'moment-duration-format';
import 'moment-timezone';

import ErrorHandler from 'components/ErrorHandler';
import App from './App';
import './lib/translations/i18n';
import './index.css';

initReactFastclick();

const store = createStore(
  rootReducer,
  /* eslint-disable no-underscore-dangle */
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

ReactDOM.render(
  <Provider store={store}>
    <ErrorHandler>
      <App />
    </ErrorHandler>
  </Provider>,
  document.getElementById('root')
);
Modal.setAppElement('#root');

// Register a minimal no-op service worker to enable PWA installability
// Enabled in production and on localhost for testing
if ('serviceWorker' in navigator) {
  const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1' ||
      window.location.hostname === '::1'
  );
  if (process.env.NODE_ENV === 'production' || isLocalhost) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').catch(() => {
        // Silently ignore registration failures to avoid impacting app behavior
      });
    });
  }
}
